import API from "./Api";

/**
 * Endpoint methods related to Moodle API Calls
 */
// import axios from "axios";

export default {
    /**
     * Creates a Moodle User with the generated payload from Back-end
     */
    async createUser(payload, data, config = null) {
        return API.post(`${window.location.origin}${payload}`, data, config);
    },

    /**
     * Gets the API Token which helps for the Moodle API Communication
     */
    async getToken(payload) {
        return API.get(`${window.location.origin}${payload}`);
    },

    /**
     * Logs in a Moodle User 
     */
    async loginUser(payload, data, config) {
        return API.post(`${window.location.origin}${payload}`, data, config);
    },

    /**
     * Enrolls a Moodle User to a Course
     */

    async enrolUser(payload, data, config = null) {
        return API.post(`${window.location.origin}${payload}`, data, config);
    },

    /**
     * Create a new company
     */
    async createCompany(payload, data, config = null) {
        return API.post(`${window.location.origin}${payload}`, data , config);
    },

    
    /**
     * Create woo users 
     */
     async createWooUsers(payload, data, config = null) {
        return API.post(`${window.location.origin}${payload}`, data , config);
    },

    /**
     * Update a company
     */
    async updateCompany(payload, data, config = null) {
        return API.post(`${window.location.origin}${payload}`, data , config);
    }
}